export const NEWS_SCREEN_CREATION_MODE = 'CREATION_MODE';
export const NEWS_SCREEN_EDIT_MODE = 'EDIT_MODE';